<header class="header">
  <img src="assets/images/bestdrive-logo.svg" alt="BestDrive" class="logo" />
</header>

<main class="main">
  <div class="card">
    <div class="icon-wrap">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <rect x="1" y="3" width="15" height="13" rx="2" />
        <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
        <circle cx="5.5" cy="18.5" r="2.5" />
        <circle cx="18.5" cy="18.5" r="2.5" />
      </svg>
    </div>

    <h1 class="headline">Töltsd le a BestDrive alkalmazást!</h1>
    <p class="subtext">
      Kezeld autód szerviz időpontjait, kövesd nyomon a munkálatokat,
      és használd ki az exkluzív ajánlatokat — mindezt egyetlen appból.
    </p>

    <div class="qr-section">
      <div class="qr-label">Szkenneld be a QR kódot</div>
      <div class="qr-code">
        <img src="assets/images/qrcodeforappstore.png" alt="QR kód" />
      </div>
      <p class="qr-hint">Irányítsd a telefonod kameráját a kódra</p>
      <p class="qr-hint">Az alkalmazás telepítése után szkenneld be ismét ezt a QR-kódot, hogy az app automatikusan a megfelelő funkcióhoz navigáljon.</p>
    </div>

    <div class="or-separator"><span>vagy</span></div>

    <div class="store-buttons">
      <a href="https://apps.apple.com/hu/app/bestdrive-magyarorsz%C3%A1g/id6757465511" class="store-btn">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
        </svg>
        <div class="store-btn-text">
          <span class="store-btn-label">Letöltés innen</span>
          <span class="store-btn-name">App Store</span>
        </div>
      </a>
      <a href="https://play.google.com/store/apps/details?id=hu.x4dsoft.bestdrive" class="store-btn">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M3.18 23.57c.14.09.3.13.46.13.14 0 .28-.03.4-.1l17.6-10c.27-.15.43-.43.43-.73s-.16-.58-.43-.73L3.98.07c-.24-.14-.53-.13-.76.02-.23.15-.37.41-.37.69v22.44c0 .28.14.54.37.69l-.04-.34zm1.63-2.2V2.63L15.04 12 4.81 21.37z" />
        </svg>
        <div class="store-btn-text">
          <span class="store-btn-label">Elérhető itt</span>
          <span class="store-btn-name">Google Play</span>
        </div>
      </a>
    </div>
  </div>
</main>

<footer class="footer">
  &copy; 2026 BestDrive Continental
</footer>
